// Mirrors internal/search.Result and the GET /api/search response shape in
// internal/server. Keep in sync with the Go struct's json tags.

export type Category = "capability" | "adr" | "design" | "runbook" | "bit";

export interface Result {
  category: Category;
  repo: string;
  id: string;
  title: string;
  snippet: string;
  url: string;
  // Set only when snippet was matched against a register field frozen at
  // the 2026-08-27 register→issues migration (see CLAUDE.md) — never for a
  // match against a capability's Live id/name. SearchResults must caption
  // it so a frozen (possibly since-corrected) claim never reads as current.
  snapshotDate?: string;
}

// CATEGORY_ORDER/LABELS match the backend's fixed append order
// (internal/search.Search) and this app's own primary-nav naming.
export const CATEGORY_ORDER: Category[] = ["capability", "adr", "design", "runbook", "bit"];

export const CATEGORY_LABELS: Record<Category, string> = {
  capability: "Capabilities",
  adr: "ADRs",
  design: "Design library",
  runbook: "Runbooks",
  bit: "B&IT gallery",
};
